module.exports = __webpack_public_path__ + "static/media/safari-icon.f915d828.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/safari-icon.png
// module id = 1410
// module chunks = 0